import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const StoreContext = createContext(null);

function load(key, fallback) {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
}

export function StoreProvider({ children }) {
  const [cart, setCart] = useState(() => load("lumeo_cart", []));
  const [compare, setCompare] = useState(() => load("lumeo_compare", []));
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => { localStorage.setItem("lumeo_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("lumeo_compare", JSON.stringify(compare)); }, [compare]);

  const addToCart = (item, qty = 1) => {
    setCart((prev) => {
      const idx = prev.findIndex((p) => p.slug === item.slug);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + qty };
        return next;
      }
      return [...prev, { ...item, qty }];
    });
    setCartOpen(true);
  };
  const removeFromCart = (slug) => setCart((prev) => prev.filter((p) => p.slug !== slug));
  const updateQty = (slug, qty) =>
    setCart((prev) => prev.map((p) => (p.slug === slug ? { ...p, qty: Math.max(1, qty) } : p)));
  const clearCart = () => setCart([]);

  const toggleCompare = (slug) => {
    setCompare((prev) => {
      if (prev.includes(slug)) return prev.filter((s) => s !== slug);
      if (prev.length >= 3) return prev;
      return [...prev, slug];
    });
  };
  const clearCompare = () => setCompare([]);

  const cartCount = cart.reduce((n, i) => n + i.qty, 0);
  const cartTotal = cart.reduce((n, i) => n + i.qty * i.price_eur, 0);

  const value = useMemo(
    () => ({ cart, cartOpen, setCartOpen, addToCart, removeFromCart, updateQty, clearCart,
             compare, toggleCompare, clearCompare, cartCount, cartTotal }),
    [cart, cartOpen, compare]
  );
  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}

export const useStore = () => {
  const ctx = useContext(StoreContext);
  if (!ctx) throw new Error("useStore must be used within StoreProvider");
  return ctx;
};
